module.exports = __webpack_public_path__ + "img/发展历程banner.a677576c.jpg";